import axios from "axios";
import Link from "next/link";
import React, { useEffect, useState } from "react";
import { useTranslation } from "next-i18next";
import { Facebook, HandCheck, Instagram, Linkedin } from "../../assets";

export default function DiscoverBeneBono() {
	const [userEmail, setUserEmail] = useState("");
	const [isEmpty, setIsEmpty] = useState(false);
	const [isSend, setIsSend] = useState(false);

	const [lang, setLang] = useState("");
	const { t } = useTranslation();

	useEffect(() => {
		const topLevelDomain = window.location.hostname.split(".").pop();
		setLang(topLevelDomain === "es" ? "es" : "fr");
	}, []);

	const susbcriptionNewsLetter = () =>
		axios
			.post("https://eo2uod9d6ddkieu.m.pipedream.net", {
				userEmail,
				lang,
			})
			.then((res) => {
				if (res) {
					setIsSend(true);
				}
			})
			.catch((error) => {
				console.log(error);
			});

	function handleChange(e) {
		setUserEmail(e.target.value);
	}

	return (
		<div className="discover_container">
			<h4>{t("discover.title")}</h4>
			<div>
				<h5>{t("discover.first.subtitle")}</h5>
				<p>{t("discover.first.description")}</p>
			</div>
			<div>
				<h5>{t("discover.second.subtitle")}</h5>
				<p>{t("discover.second.description")}</p>
			</div>
			<div>
				<h5>{t("discover.third.subtitle")}</h5>
				<p>{t("discover.third.description")}</p>
			</div>
			<Link href="/checkout" className="button">
				{t("button.baskets")}
			</Link>
			<span />
			<h4>{t("newsletter.title")}</h4>
			{!isSend ? (
				<>
					<p>{t("newsletter.description")}</p>
					<input
						onChange={handleChange}
						type="email"
						placeholder="manuel@exemple.com"
					/>
					<div
						className="button"
						onClick={() => {
							if (userEmail) {
								susbcriptionNewsLetter();
							}
							if (!userEmail) {
								setIsEmpty(true);
							}
						}}
					>
						{t("newsletter.button")}
					</div>
				</>
			) : (
				<div className="success_newsletter">
					<HandCheck />
					<p>{t("newsletter.already.subscribe")}</p>
				</div>
			)}
			{isEmpty && !isSend ? (
				<p
					style={{
						color: "red",
						margin: 0,
						marginTop: "5px",
						paddingLeft: "10px",
					}}
				>
					{t("email.error.format")}
				</p>
			) : null}

			<span />
			<h4>{t("socials.title")}</h4>
			<p>{t("socials.description")}</p>
			<div className="socials_container">
				<a
					target="_blank"
					rel="noreferrer"
					href={
						lang === "es"
							? "https://www.instagram.com/benebono.es/"
							: "https://www.instagram.com/benebono.fr/"
					}
				>
					<Instagram />
				</a>
				<a
					target="_blank"
					rel="noreferrer"
					href={
						lang === "es"
							? "https://www.facebook.com/benebono.es/"
							: "https://www.facebook.com/benebono.fr/"
					}
				>
					<Facebook />
				</a>
				<a
					target="_blank"
					rel="noreferrer"
					href={
						lang === "es"
							? "https://www.linkedin.com/company/benebono-fr"
							: "https://www.linkedin.com/company/benebono-fr"
					}
				>
					<Linkedin />
				</a>
			</div>
		</div>
	);
}
